<template>
    <div class="g-content g-autofixheight order order-taking">
        <!-- 接单确认[[ -->
        <div
            class="g-popup g-popup-transparent js-popup-confirm-order"
            v-if="relativePersonDialog.show"
        >
            <div class="popup-con confirm-zero-popup">
                <div class="popup-close js-close-view">
                    <i class="ico ico-close" @click="relativePersonDialog.show=false"></i>
                </div>
                <h5 class="popup-title">确认关联人及金额、接单</h5>
                <p class="confim-content">
                    接单需完成订单关联人及金额设定，
                    <br>是否新增关联人接单？
                </p>
                <div class="btn-group f-clearfix">
                    <a
                        class="g-btn new-built-btn"
                        href="javascript:;"
                        @click="viewAuthorOrderDetail(relativePersonDialog.authorOrderInfo)"
                    >新增</a>
                    <a
                        class="g-btn cancell f-fr"
                        href="javascript:;"
                        @click="relativePersonDialog.show = false"
                    >取消</a>
                </div>
            </div>
        </div>
        <!-- 接单确认]] -->

        <!-- 提请结单[[ -->
        <div
            class="g-popup g-popup-transparent js-popup-statement"
            v-if="authorOrderInfoDialog.show"
            style="z-index: 100"
        >
            <div
                class="popup-con confirm-zero-popup popup-statement-con"
                v-loading="submitOrderLoading"
            >
                <div class="popup-close js-close-view">
                    <i class="ico ico-close" @click="authorOrderInfoDialog.show = false"></i>
                </div>
                <h5 class="popup-title">提请结单</h5>
                <p class="confim-content">
                    请再次确认关联人及金额，提请结束后将不可更改金额
                    <br>关联人总金额需同实际额一致
                </p>
                <div class="order-details">
                    <div class="order-type-num f-clearfix">
                        <div class="order-types f-fl order-types-left">
                            <div class="order-type">
                                图文:
                                <div class="num-details">
                                    <span class="num">{{ authorOrderInfo.articlesPass }}/</span>
                                    {{ authorOrderInfo.articlesPre }}
                                </div>
                            </div>
                            <div class="order-type">
                                小说:
                                <div class="num-details">
                                    <span class="num">{{ authorOrderInfo.novelPass }}/</span>
                                    {{ authorOrderInfo.novelPre }}
                                </div>
                            </div>
                            <div class="order-type">
                                视频:
                                <div class="num-details">
                                    <span class="num">{{ authorOrderInfo.videoPass }}/</span>
                                    {{ authorOrderInfo.videoPre }}
                                </div>
                            </div>
                            <div class="order-type">
                                漫画:
                                <div class="num-details">
                                    <span class="num">{{ authorOrderInfo.cartoonPass }}/</span>
                                    {{ authorOrderInfo.cartoonPre }}
                                </div>
                            </div>
                        </div>
                        <div class="order-types f-fr">
                            <div class="order-type">
                                税后总预算:
                                <div
                                    class="num-details"
                                >{{ $common.toThousandsFilter(authorOrderInfo.totalBudgetTax)}}</div>
                            </div>
                            <div class="order-type">
                                税后实际额:
                                <div
                                    class="num-details color-theme"
                                >{{ $common.toThousandsFilter(authorOrderInfo.realConfirmAmount)}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="statement-list-box g-scrollbar">
                        <ul class="statement-list">
                            <li
                                class="statement-list-con"
                                v-for="(person,index) in relativePersonList"
                                :key="index"
                            >
                                <div class="list-con-left f-inlineblock-middle">
                                    <p
                                        class="list-con-name f-hide-col-1"
                                    >{{ person.login_user_name }}</p>
                                    <p class="list-con-id f-hide-col-1">{{ person.login_name }}</p>
                                </div>
                                <div class="list-con-center f-inlineblock-middle">
                                    <p class="list-con-text f-hide-col-2">{{ person.task_remark }}</p>
                                </div>
                                <div class="list-con-right f-inlineblock-middle">
                                    <span class="list-con-sign">&yen;</span>
                                    <input
                                        class="list-con-money g-input"
                                        type="text"
                                        v-model="person.amount"
                                        @change="saveRelativePerson(person)"
                                    >
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="btn-group f-clearfix">
                    <a
                        class="g-btn statement-btn"
                        href="javascript:;"
                        @click="doSubmitAuthorOrder(authorOrderInfo.id)"
                    >提请结单</a>
                    <a
                        class="g-btn cancell f-fr"
                        href="javascript:;"
                        @click="authorOrderInfoDialog.show = false"
                    >取消</a>
                </div>
            </div>
        </div>
        <!-- 提请结单]] -->

        <div class="my-order-tabs my-order-tab-1">
            <div class="g-status">
                <a class="arrow-left js-status-left" href="#" @click="swiperPrev">
                    <i class="ico ico-arrow-left"></i>
                </a>
                <a class="arrow-right js-status-right" href="#" @click="swiperNext">
                    <i class="ico ico-arrow-right"></i>
                </a>
                <div class="swiper-container js-status-swiper" id="swiper-tab">
                    <div class="swiper-wrapper">
                        <div
                            class="swiper-slide"
                            v-for="(item,index) in pageConf.authorOrderStatusList"
                            :key="item.id"
                        >
                            <div
                                class="title"
                                :class="{active: index == curSwiper}"
                                @click="changeSwiper(index,item)"
                            >
                                {{item.name}}
                                <span class="num">（{{item.num}}）</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="search f-clearfix">
                <select-box
                    style="font-size: 14px;color:#666"
                    :selectList="allGame"
                    :itemTitle="'游戏'"
                    :selected.sync="params.gameId"
                ></select-box>
                <select-box
                    style="font-size: 14px;color:#666"
                    :selectList="pageConf.contentTypeList"
                    :itemTitle="'订单类型'"
                    :selected.sync="params.type"
                    :placeHolder="'请选择订单类型'"
                ></select-box>

                <div class="list list-order-name">
                    <!--<div class="list">-->
                    <p class="name">
                        <label for="keyword">订单名称</label>
                    </p>
                    <div class="g-select f-fl">
                        <input
                            class="input"
                            name="keyword"
                            type="text"
                            placeholder="请输入订单名称"
                            v-model.trim="params.demandName"
                        >
                    </div>
                </div>
                <div class="inquire">
                    <input class="btn" type="button" value="查询" @click="getAuthorOrderList">
                </div>
            </div>
            <ul class="order-list">
                <li
                    class="order-item f-clearfix"
                    v-for="(authorOrder,index) in authorOrderList"
                    :key="index"
                >
                    <a
                        class="click-area"
                        href="javascript:;"
                        @click="viewAuthorOrderDetail(authorOrder)"
                    >
                        <div class="item-head">
                            <img :src="authorOrder.logoUrl" width="80" height="80">
                        </div>
                        <div class="item-intro">
                            <div class="item-name f-hide-col-1">
                                <p class="link">{{ authorOrder.order_name}}</p>
                            </div>
                            <div class="order-intro">
                                <span class="order-num">
                                    <span class="order-num-text">单号：</span>
                                    {{ authorOrder.id}}
                                </span>
                                <span class="order-type">{{ authorOrder.demandTypeText }}</span>
                            </div>
                            <div class="date">
                                <span class="date-detail">{{ authorOrder.gameName}}</span>
                                {{ authorOrder.start_time}}-{{ authorOrder.end_time }}
                            </div>
                        </div>
                        <div class="budget">
                            <div class="budget-all">
                                含税总预算
                                <span
                                    class="budget-all-num f-hide-col-1"
                                >{{$common.toThousandsFilter(authorOrder.totalBudgetTax)}}</span>
                            </div>
                            <div class="budget-true">
                                含税实际额
                                <span
                                    class="budget-true-num f-hide-col-1"
                                >{{$common.toThousandsFilter(authorOrder.realAmountTax)}}</span>
                            </div>
                        </div>
                    </a>

                    <!-- 待接单[[ -->
                    <div class="status wait-accept f-fr" v-if="authorOrder.order_status == 6002">
                        <div class="status-text">待接单</div>
                        <div class="operation">
                            <!--<a class="g-btn js-order-taking" href="javascript:;"-->
                            <!--style="width: 100px;margin: 30px 0 18px"-->
                            <!--@click="viewAuthorOrderDetail(authorOrder)">-->
                            <!--编辑关联人金额-->
                            <!--</a>-->
                            <a
                                class="g-btn js-order-taking"
                                href="javascript:;"
                                @click="acceptOrder(authorOrder)"
                            >接单</a>
                        </div>
                    </div>
                    <!-- 已接单[[ -->
                    <div
                        class="status wait-check f-fr"
                        v-else-if="authorOrder.order_status == 6003"
                    >
                        <div class="status-text">已接单</div>
                    </div>
                    <!-- 已接单]] -->
                    <!-- 待审核[[ -->
                    <div
                        class="status wait-check f-fr"
                        v-else-if="authorOrder.order_status == 6004"
                    >
                        <div class="status-text">待审核</div>
                    </div>
                    <!-- 待审核]] -->
                    <!-- 已结单[[ -->
                    <div
                        class="status wait-check-failure f-fr"
                        v-else-if="authorOrder.order_status == 6005"
                    >
                        <div class="status-text">已驳回</div>
                        <!--<p class="rebut-text f-hide-col-1">存在敏感词汇</p>-->
                    </div>
                    <!-- 已结单]] -->

                    <!-- 执行中[[ -->
                    <div
                        class="status wait-accept f-fr"
                        v-else-if="authorOrder.order_status == 6006"
                    >
                        <div class="status-text">执行中</div>
                        <div class="operation">
                            <a class="g-btn" href="javascript:;" @click="contribute(authorOrder)">投稿</a>
                            <a
                                class="g-btn js-statement"
                                href="javascript:;"
                                v-if="authorOrder.isReceiver"
                                @click="submitAuthorOrder(authorOrder)"
                            >提请结单</a>
                        </div>
                    </div>
                    <!-- 执行中]] -->
                    <!-- 待结单[[ -->
                    <div
                        class="status wait-check f-fr"
                        v-else-if="authorOrder.order_status == 6007"
                    >
                        <div class="status-text">待结单</div>
                    </div>
                    <!-- 待结单]] -->

                    <!-- 待结算[[ -->
                    <div
                        class="status wait-check f-fr"
                        v-else-if="authorOrder.order_status == 6008"
                    >
                        <div class="status-text">待结算</div>
                    </div>
                    <!-- 待结算]] -->

                    <!-- 结算中[[ -->
                    <div
                        class="status wait-check f-fr"
                        v-else-if="authorOrder.order_status == 6009"
                    >
                        <div class="status-text">结算中</div>
                    </div>
                    <!-- 结算中]] -->
                    <!-- 支付成功[[ -->
                    <div
                        class="status charge-confirm f-fr"
                        v-else-if="authorOrder.order_status == 6010"
                    >
                        <div class="status-text">支付成功</div>
                    </div>
                    <!-- 支付成功]] -->
                    <!-- 支付失败[[ -->
                    <div class="status interrupt f-fr" v-else-if="authorOrder.order_status == 6011">
                        <div class="status-text">支付失败</div>
                    </div>
                    <!-- 支付失败]] -->
                    <!-- 已结单[[ -->
                    <div
                        class="status charge-confirm f-fr"
                        v-else-if="authorOrder.order_status == 6020"
                    >
                        <div class="status-text">已中止</div>
                    </div>
                    <!-- 已结单]] -->
                    <!-- 终止结算[[ -->
                    <div
                        class="status charge-confirm f-fr"
                        v-else-if="authorOrder.order_status == 6021"
                    >
                        <div class="status-text">终止结算</div>
                    </div>
                    <!-- 终止结算]] -->
                </li>
            </ul>
            <!-- 分页[[ -->
            <pagination
                v-if="paginationConf.total >0"
                :total="paginationConf.total"
                :page-size="paginationConf.pageSize"
                @change="pageChange"
                ref="pager"
            ></pagination>
            <!-- 分页]] -->
            <!-- 空数据 start -->
            <div class="empty" v-if="authorOrderList.length===0">
                <img class="empty-img" src="~Assets/img/pages/v4/radar-no-result.png">
            </div>
            <!-- 空数据 end -->
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/order/order.scss";
@import "~Assets/vendor/swiper/swiper-3.2.7.min.css";
@import "~Assets/sass/pages/v4/order/order_taking.scss";
</style>
<script>
import Swiper from "Assets/vendor/swiper/swiper-3.2.7.min.js";
import selectBox from "Components/v4/dropdown/select_box";
import pagination from "Components/v4/pagination/pagination_v4";
import {
    AllGame,
    SupplierDemandList,
    SupplierDemanStat,
    AuthorOrderStat,
    AuthorOrderList,
    AuthorSubmitAuthorOrder,
    AuthorAcceptOrder,
    AuthorOrderInfo,
    AuthorOrderRelationList,
    AddRelativePerson
} from "Services/getData.js";
export default {
    name: "author_order_list.vue",
    data() {
        return {
            pageConf: {
                demandStatusList: [
                    {
                        id: 0,
                        name: "全部",
                        num: ""
                    },
                    {
                        id: 4003,
                        name: "执行中",
                        num: ""
                    },
                    {
                        id: 4004,
                        name: "已结单",
                        num: ""
                    }
                ],
                contentTypeList: [
                    {
                        id: 0,
                        name: "全部类型"
                    },
                    {
                        id: 1,
                        name: "PGC"
                    },
                    {
                        id: 2,
                        name: "PUGC"
                    },
                    {
                        id: 3,
                        name: "UGC"
                    }
                ],
                demandTypeList: [
                    {
                        name: "内容创作",
                        id: 10
                    },
                    {
                        name: "劳务服务",
                        id: 20
                    },
                    {
                        name: "福利奖金",
                        id: 30
                    },
                    {
                        name: "补贴补偿",
                        id: 40
                    }
                ],
                authorOrderStatusList: [
                    {
                        id: 0,
                        name: "全部",
                        enName: "all",
                        num: ""
                    },
                    // {id:6001, name: '制单中', enName: '',operation:['edit','delete']},
                    {
                        id: 6002,
                        name: "待接单",
                        enName: "toReceive",
                        num: "",
                        operation: ["stop"]
                    },
                    {
                        id: 6003,
                        name: "已接单",
                        enName: "hasReceive",
                        num: "",
                        operation: ["stop"]
                    },
                    {
                        id: 6004,
                        name: "待审核",
                        enName: "toAudit",
                        num: "",
                        operation: []
                    },
                    {
                        id: 6005,
                        name: "已驳回",
                        enName: "reject",
                        num: "",
                        operation: []
                    },
                    {
                        id: 6006,
                        name: "执行中",
                        enName: "execute",
                        num: "",
                        operation: []
                    },
                    {
                        id: 6007,
                        name: "待结单",
                        enName: "toFinish",
                        num: "",
                        operation: ["supplierStop"]
                    },
                    {
                        id: 6008,
                        name: "待结算",
                        enName: "toStatement",
                        num: "",
                        operation: ["reject"]
                    },
                    {
                        id: 6009,
                        name: "结算中",
                        enName: "statementing",
                        num: "",
                        operation: []
                    },
                    {
                        id: 6010,
                        name: "支付成功",
                        enName: "paySuccess",
                        num: "",
                        operation: []
                    },
                    {
                        id: 6011,
                        name: "支付失败",
                        enName: "payFailed",
                        num: "",
                        operation: []
                    },
                    // {id:6012, name: '支付中',operation:[]},
                    {
                        id: 6020,
                        name: "已中止",
                        enName: "over",
                        num: "",
                        operation: []
                    },
                    {
                        id: 6021,
                        name: "终止结算",
                        enName: "stopSettle",
                        num: "",
                        operation: []
                    }
                ]
            },
            mySwiper: {},
            curSwiper: 0,
            allGame: [],
            supplierDemandList: [],
            params: {
                authorOrderStatus: 0,
                gameId: "",
                authorOrderName: "",
                pageSize: "",
                pageIndex: 0 // 从 0 开始
            },
            authorOrderList: [],
            paginationConf: {
                total: 0,
                pageSize: 10
            },
            authorOrderInfoDialog: {
                show: false
            },
            authorOrderInfo: {},
            relativePersonList: [], // 当前订单关联人列表
            relativePersonDialog: {
                show: false,
                authorOrderInfo: {}
            },
            submitOrderLoading: false
        };
    },
    components: {
        selectBox,
        pagination
    },
    created() {
        this.getAuthorOrderStat().then(() => {
            this.initSwiper();
        });
    },
    mounted() {
        this.getAllGame();
        this.getAuthorOrderList();
    },
    methods: {
        acceptOrder(order) {
            //检查关联人信息，有，直接提交， 无，弹窗
            this.getRelativePersonList(order).then(() => {
                if (!this.relativePersonList.length) {
                    this.relativePersonDialog.show = true;
                    this.relativePersonDialog.authorOrderInfo = order;
                } else {
                    this.$confirm(`确认接单吗？`, "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消"
                    })
                        .then(() => {
                            this.doAcceptAuthorOrder(order);
                        })
                        .catch(() => {});
                }
            });
        },
        submitAuthorOrder(order) {
            this.getRelativePersonList(order);
            this.getAuthorOrderInfo(order).then(() => {
                this.authorOrderInfoDialog.show = true;
            });
        },
        initSwiper() {
            this.mySwiper = new Swiper("#swiper-tab", {
                paginationClickable: true,
                slidesPerView: "auto",
                initialSlide: 1,
                slideToClickedSlide: true,
                centeredSlides: true,
                onTransitionEnd: function(swiper) {
                    if (swiper.progress == 1) {
                        swiper.activeIndex = swiper.slides.length - 1;
                    }
                }
            });
        },
        swiperPrev() {
            this.mySwiper.slidePrev();
        },
        swiperNext() {
            this.mySwiper.slideNext();
        },
        changeSwiper(index, item) {
            this.curSwiper = index;
            this.params.pageIndex = 0;
            this.params.authorOrderStatus = item.id;
            this.getAuthorOrderList();
        },
        pageChange(param) {
            // this.params.pageSize = param.pageSize; // 发送给接口的字段
            this.params.pageIndex = param.pageIndex - 1; // 发送给接口的字段
            this.getAuthorOrderList();
        },
        contribute(order) {
            // 投稿
            // order.type = 'authorOrder';
            // this.$router.history.push({name:'v4-order-contribute',params:order});
            this.$router.history.push({
                name: "v4-order-contribute",
                query: {
                    authorOrderId: order.id
                }
            });
        },
        viewAuthorOrderDetail(order) {
            this.$router.history.push({
                name: "v4-order-related-author-charge",
                query: {
                    id: order.id
                }
            });
        },
        saveRelativePerson(person) {
            this.submitOrderLoading = true;
            let { id, login_name, task_remark, amount } = person;
            let param = {
                authorOrderId: this.authorOrderInfo.id,
                qq: login_name,
                id,
                remark: task_remark,
                amount
            };
            this.doSaveRelativePerson(param).then(() => {
                this.submitOrderLoading = false;
            });
        },
        async doAcceptAuthorOrder(order) {
            let response = await AuthorAcceptOrder({
                authorOrderId: order.id
            });
            let result = response.data;
            if (result.code === 0) {
                this.$alert("操作成功");
                this.getAuthorOrderList();
            }
        },
        async doSaveRelativePerson(param) {
            // 保存关联人信息
            let response = await AddRelativePerson(param);
            let result = response.data;
            if (result.code === 0) {
                this.$alert("操作成功");
                this.relativePersonDialog.show = false;
            }
        },
        async doSubmitAuthorOrder(id) {
            // 提请结单
            let response = await AuthorSubmitAuthorOrder({
                authorOrderId: id
            });
            let result = response.data;
            if (result.code === 0) {
                this.$alert("操作成功");
                this.authorOrderInfoDialog.show = false;
                this.getAuthorOrderList();
            }
        },
        async getAuthorOrderInfo(order) {
            let res = await AuthorOrderInfo({
                authorOrderId: order.id
            });
            if (res.status === 200 && res.data.code == 0) {
                if (res.data.code == 0) {
                    let data = res.data.data;
                    this.authorOrderInfo = data;
                }
            }
        },
        async getRelativePersonList(order) {
            let param = {
                authorOrderId: order.id,
                pageSize: 10000,
                pageIndex: 0
            };
            let res = await AuthorOrderRelationList(param);
            if (res.status === 200 && res.data.code == 0) {
                if (res.data.code == 0) {
                    let data = res.data.data;
                    this.relativePersonList = data.data;
                }
            }
        },
        async getAuthorOrderStat() {
            let res = await AuthorOrderStat();
            if (res.status === 200 && res.data.code == 0) {
                if (res.data.code == 0) {
                    let data = res.data.data;
                    this.pageConf.authorOrderStatusList.map(v => {
                        v.num = data[v.enName] ? data[v.enName] : 0;
                    });
                }
            }
        },
        async getAuthorOrderList() {
            let param = this.params;
            let res = await AuthorOrderList(param);
            if (res.status === 200 && res.data.code == 0) {
                let data = res.data;
                if (data.code != 0) {
                    // this.$alert(data.info);
                } else {
                    let authorOrderList = data.data.data;
                    let demandTypeList = {};
                    this.pageConf.demandTypeList.filter(type => {
                        demandTypeList[type.id] = type.name;
                    });
                    this.authorOrderList = authorOrderList.map(order => {
                        order.demandTypeText =
                            demandTypeList[order.demand_type];
                        return order;
                    });
                    this.paginationConf.total = data.data.count;
                }
            }
        },
        async getAllGame() {
            let res = await AllGame();
            if (res.data && res.data.data.length) {
                this.allGame = res.data.data;
                this.allGame.unshift({
                    id: 0,
                    name: "全部"
                });
            }
        }
    }
};
</script>

